import ReactGA from 'react-ga4';
import { useEffect } from "react";
import { getCookie } from '../../../services/cookies'
import config from '../../../config';

export const useAnalytics = () => {
  const trackEvent = (eventName, eventParams) => {
    if (config.env === 'production') {
      const formattedParams = {
        ...eventParams,
        timestamp: new Date().toISOString(),
        user_email: getCookie('email'),
      };

      try {
        ReactGA.event(eventName, formattedParams);
      } catch (error) {
        console.error('Error tracking event:', error);
      }
    }
  };

  useEffect(() => {
    if (!ReactGA.isInitialized && config.env === 'production') {
      ReactGA.initialize([
        {
          trackingId: "G-7D75QRG3E4",
          gaOptions: {
            userId: getCookie('email'),
          }
        }
      ]);
    }
  }, []);

  return {
    trackEvent
  };
};